import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import closeIcon from "assets/images/close.png";
class CommonTableClass extends Component {
  render() {
    let { t } = this.props;
    return (
      <div className="customerSearch-block">
        <div className="closeIconParent">
          <img
            onClick={() => this.props.handleClose()}
            className="close cursor-pointer close-flexEnd"
            src={closeIcon}
            alt=""
          />
        </div>
        <div className="d-flex mt-4 table table-header w-100 m-0">
          <div className="col-2">{t("Name")}</div>
          <div className="col-2">{t("Phone")}</div>
          <div className="col-2">{t("Cust Code")}</div>
          <div className="col-2">{t("Reference")}</div>
          <div className="col-3">{t("Email")}</div>
          <div className="col-1 d-none">{t("NRIC")}</div>
        </div>
        <div className="response-table w-100">
          {this.props.customerOption.length > 0 ? (
            this.props.customerOption.map((item, index) => {
              return (
                <div
                  className="row m-0 table-body w-100 border"
                  onClick={() => this.props.handleSelectCustomer(item)}
                  key={index}
                >
                  <div className="col-2">{item.cust_name}</div>
                  <div className="col-2">{item.cust_phone2}</div>
                  <div className="col-2">{item.cust_code}</div>
                  <div className="col-2">{item.cust_refer}</div>
                  <div className="col-3">{item.cust_email}</div>
                  <div className="col-1 d-none">{item.cust_nric}</div>
                </div>
              );
            })
          ) : (
            <div className="text-center w-100">
              {t("No Data are available")}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export const CommonTable = withTranslation()(CommonTableClass);
